
//Libraries
import { defineComponent, onMounted, ref } from "vue";

//Components
import UserGame from "../../shared/components/game/UserGame.vue";
import LoadingBar from "../../shared/components/LoadingBar.vue";

export default defineComponent({
  name: "GamesContentHomeModule",
  components: {
    LoadingBar,
    UserGame,
  },
  setup() {
    //Data

    const isLoading = ref<boolean>(true);

    const games = ref<any>([]);

    //Methods

    const getData = async (): Promise<any> => {
      return true;
    };

    //Lifecycle Hooks

    onMounted(() => {
      getData().then(() => {
        games.value = [
          {
            id: "a",
          },
          {
            id: "b",
          },
          {
            id: "c",
          },
          {
            id: "d",
          },
        ];
        setTimeout(() => {
          isLoading.value = false;

          setTimeout(() => {
            isLoading.value = false;
          }, 600);
        }, 500);
      });
    });

    return {
      //Data
      isLoading,
      games,
    };
  },
});
